import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControl,
  ListItem,
  ListItemText,
  makeStyles,
  InputLabel,
  Typography,
} from "@material-ui/core";
import {
  clear,
  selectProducttype,
  getListofProducttype,
  set,
} from "./producttypeSlice";
import { red } from "@material-ui/core/colors";
import { getPrimaryBu } from "../productgroup/productgroupSlice";
import { selectLanguage } from "../language/languageSlice";

import { pushList as pushRequestProductToList } from "../requestProduct/requestproductSlice";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
  },
  prdlv2: {
    paddingLeft: "4vw",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
    "& > *": {},
  },
  prdlv3: {
    paddingLeft: "8vw",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
    "& > *": {},
  },
  prdlv4: {
    paddingLeft: "16vw",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
  textHilight: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
  title: {
    fontSize: 24,
  },
}));

export function Producttype() {
  const classes = useStyles();
  const currentProducttype = useSelector(selectProducttype);
  const activeSelectingBu = useSelector(getPrimaryBu);
  const listOfProducttype = useSelector(getListofProducttype);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  let Header = [];
  if (listOfProducttype.length > 0) {
    Header.push(
      <Typography id="Producttype-input-label" className={classes.title}>
        {language === "TH" ? "ประเภทผลิตภัณฑ์" : "Product Type"}
      </Typography>
    );
  }
  return (
    <React.Fragment>
      {/* //
      <FormControl className={classes.formControl}> */}
      {Header}
      {listOfProducttype.map((Producttype) => {
        let returnResult = [];

        returnResult.push(
          <ListItem
            button
            divider
            disabled={Producttype.Product.length > 0 ? true : false}
            className={classes.textHilight}
            onClick={() => {
              let newRequestProduct = {};
              newRequestProduct["id"] = Producttype.id;
              newRequestProduct["buId"] = activeSelectingBu;
              newRequestProduct["Name"] = Producttype.Name;
              newRequestProduct["minQty"] = Producttype.minQty;
              newRequestProduct["Unit"] =
                Producttype.Unit != null ? Producttype.Unit : [];
              newRequestProduct["Product"] = Producttype.Product;
              newRequestProduct["CurrentVol"] = 0;
              newRequestProduct["CurrentUnit"] =
                Producttype.Unit != null ? Producttype.Unit[0].id : null;
              dispatch(pushRequestProductToList(newRequestProduct));
            }}
          >
            <ListItemText primary={Producttype.Name} />
          </ListItem>
        );
        returnResult.push(
          Producttype.Product.map((Producttype) => {
            let lv2 = [];
            lv2.push(
              <ListItem
                button
                divider
                disabled={Producttype.Product.length > 0 ? true : false}
                className={classes.prdlv2}
                onClick={() => {
                  let newRequestProduct = {};
                  newRequestProduct["id"] = Producttype.id;
                  newRequestProduct["buId"] = activeSelectingBu;
                  newRequestProduct["Name"] = Producttype.Name;
                  newRequestProduct["minQty"] = Producttype.minQty;
                  newRequestProduct["Unit"] =
                    Producttype.Unit != null ? Producttype.Unit : [];
                  newRequestProduct["Product"] = Producttype.Product;
                  newRequestProduct["CurrentVol"] = 0;
                  newRequestProduct["CurrentUnit"] =
                    Producttype.Unit != null ? Producttype.Unit[0].id : null;
                  dispatch(pushRequestProductToList(newRequestProduct));
                }}
              >
                <ListItemText
                  primary={Producttype.Name}
                  //className={classes.textHilight}
                />
              </ListItem>
            );
            lv2.push(
              Producttype.Product.map((Producttype) => {
                let lv3 = [];
                lv3.push(
                  <ListItem
                    button
                    divider
                    disabled={Producttype.Product.length > 0 ? true : false}
                    className={classes.prdlv3}
                    onClick={() => {
                      let newRequestProduct = {};
                      newRequestProduct["id"] = Producttype.id;
                      newRequestProduct["buId"] = activeSelectingBu;
                      newRequestProduct["Name"] = Producttype.Name;
                      newRequestProduct["minQty"] = Producttype.minQty;
                      newRequestProduct["Unit"] =
                        Producttype.Unit != null ? Producttype.Unit : [];
                      newRequestProduct["Product"] = Producttype.Product;
                      newRequestProduct["CurrentVol"] = 0;
                      newRequestProduct["CurrentUnit"] =
                        Producttype.Unit != null
                          ? Producttype.Unit[0].id
                          : null;
                      dispatch(pushRequestProductToList(newRequestProduct));
                    }}
                  >
                    <ListItemText primary={Producttype.Name} />
                  </ListItem>
                );
                lv3.push(
                  Producttype.Product.map((Producttype) => {
                    let lv4 = [];
                    lv4.push(
                      <ListItem
                        button
                        divider
                        disabled={Producttype.Product.length > 0 ? true : false}
                        className={classes.prdlv4}
                        onClick={() => {
                          let newRequestProduct = {};
                          newRequestProduct["id"] = Producttype.id;
                          newRequestProduct["buId"] = activeSelectingBu;
                          newRequestProduct["Name"] = Producttype.Name;
                          newRequestProduct["minQty"] = Producttype.minQty;
                          newRequestProduct["Unit"] =
                            Producttype.Unit != null ? Producttype.Unit : [];
                          newRequestProduct["CurrentVol"] = 0;
                          newRequestProduct["Product"] = Producttype.Product;
                          newRequestProduct["CurrentUnit"] =
                            Producttype.Unit != null
                              ? Producttype.Unit[0].id
                              : null;
                          dispatch(pushRequestProductToList(newRequestProduct));
                        }}
                      >
                        <ListItemText primary={Producttype.Name} />
                      </ListItem>
                    );

                    return lv4;
                  })
                );
                return lv3;
              })
            );
            return lv2;
          })
        );
        return returnResult;
      })}

      {/*  </FormControl> */}
    </React.Fragment>
  );
}
